import React from 'react'

const TextField = ({ label, staticField = false, policyAddressInfo }) => {
    return (
        <div className='row my-3 d-flex justify-content-start'>
            <div className='col-12 col-sm-6 col-md-6'>
                <p className='text-primary fw-bold field'>
                    {label}*
                </p>
            </div>
            <div className='col-12 col-sm-5 col-md-6'>
                {staticField &&
                    <p className='fw-bold'>
                        {policyAddressInfo.address1}<br />
                        {`${policyAddressInfo?.city}, ${policyAddressInfo?.state + " " + policyAddressInfo?.zip?.substring(0, 5)}`}
                    </p>
                }
            </div>
        </div>
    )
}

export default TextField